import { Link } from "react-router-dom";

export default function LegalLayout({ children, title }) {
  return (
    <div className="min-h-screen bg-gradient-to-tr from-cyan-500/80 via-blue-600 to-cyan-950 font-sans text-cyan-50 flex flex-col">
      {/* Header/Nav */}
      <header className="sticky top-0 z-30 px-4 sm:px-8 py-4 bg-cyan-950/80 border-b border-cyan-400/20 shadow-xl backdrop-blur-lg flex justify-between items-center">
        <Link to="/" className="font-extrabold font-mono tracking-wider text-cyan-200 drop-shadow-glow text-2xl sm:text-3xl">
          MockWit.ai
        </Link>
        <nav className="flex gap-4">
          <Link to="/privacy" className="hover:underline text-cyan-50 font-mono">Privacy Policy</Link>
          <Link to="/terms" className="hover:underline text-cyan-50 font-mono">Terms of Use</Link>
        </nav>
      </header>

      {/* Content */}
      <main className="flex-1 w-full max-w-3xl mx-auto px-4 py-12">
        {children}
      </main>

      {/* Footer */}
      <footer className="mt-12 pb-8 pt-8 px-4 text-center text-cyan-200/90 text-sm border-t border-cyan-200/30 bg-cyan-950/80 backdrop-blur-lg">
        <div className="mb-2">
          &copy; {new Date().getFullYear()} <span className="text-cyan-100 font-mono drop-shadow-glow">MockWit.ai</span>. All rights reserved.
        </div>
        <span className="opacity-80">Made with <span className="text-pink-300">❤️</span> by AI innovators</span>
      </footer>
    </div>
  );
}
